module.exports = "/assets/data/a912be37fe45f2fcc7aad3124f7a3652-NE34.data.json";